/* eslint-disable */
import {UserRoles as UserRolesOrig} from '../types/UserRoles'
import {UserRoles_me as UserRoles_meOrig} from '../types/UserRoles'

/* tslint:disable */

/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
// ====================================================
// GraphQL query operation: UserRoles
// ====================================================
export interface UserRoles_me {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
  roles: string[]
}
export const deserializeUserRoles_me = (
  serialized: UserRoles_meOrig
): UserRoles_me => ({...serialized})
export const serializeUserRoles_me = (
  deserialized: UserRoles_me
): UserRoles_meOrig => ({...deserialized})
export interface UserRoles {
  /**
   * Currently authenticated user
   */
  me: UserRoles_me
}
export const deserializeUserRoles = (serialized: UserRolesOrig): UserRoles => ({
  ...serialized,
  me: deserializeUserRoles_me(serialized.me),
})
export const serializeUserRoles = (deserialized: UserRoles): UserRolesOrig => ({
  ...deserialized,
  me: serializeUserRoles_me(deserialized.me),
})
